// extracted by mini-css-extract-plugin
export default {"content":"style_content__+i59a","leftSide":"style_leftSide__wUUB8","rightSide":"style_rightSide__blC8Y","type":"style_type__qIfnS"};